module.exports = __webpack_public_path__ + "static/media/16.ba7e13fe.jpg";